import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateLoad, UpdateLoadParams } from "@/api/vendor/updateLoad";

import { GetLoadsResponse } from "@/api/vendor/getLoads";
import { sonner } from "@/components/ui/useSonner";

export function useLoadMutations() {
    const queryClient = useQueryClient();
    const toast = sonner();

    const updateLoadMutation = useMutation({
        mutationFn: (params: UpdateLoadParams) => updateLoad(params),
        onSuccess: (updatedLoad, variables) => {
            queryClient.invalidateQueries({ queryKey: ["loads", "receiver"] });

            toast.success("Load Updated Successfully", {
                description: "Your freight load has been updated",
            });
        },
        onError: (error) => {
            console.error("Error updating load:", error);
            toast.error("Failed to Update Load", {
                description:
                    "Please try again or contact support if the problem persists",
            });
        },
    });

    return {
        updateLoad: updateLoadMutation,
        isUpdating: updateLoadMutation.isPending,
    };
}
